import { Injectable } from '@angular/core';
import { filterUndefined } from 'src/app/lego-utils';
import { NEVER, Observable } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { DesignDataService } from 'src/app/services';
import { handleError } from './akita-error-helper';
import { CollectionState } from './collection-state';
import { SessionService } from './session.service';
import { Design } from 'src/app/models/domain';

@Injectable({ providedIn: 'root' })
export class MyWorklistService {
  private readonly state = new CollectionState<Design>();

  public readonly worklistItems$ = this.state.items$;
  public readonly loading$ = this.state.loading$;
  public readonly error$ = this.state.error$;

  public constructor(
    private readonly sessionService: SessionService,
    private readonly designDataService: DesignDataService
  ) {}

  public loadWorklistItems(): Observable<void> {
    this.state.setLoading(true);

    return this.sessionService.userShortName$.pipe(
      filterUndefined(),
      switchMap((userId) => this.designDataService.getByResponsibleUser(userId)),
      tap((designs) => {
        this.state.set(designs);
      }),
      catchError((error) => {
        handleError(this.state, error);

        return NEVER;
      }),
      map(() => undefined)
    );
  }
}
